import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  constructor(
    private readonly snackBar: MatSnackBar,
    private readonly translateService: TranslateService
  ) {}

  success(translationKey: string, interpolateParams?: object): void {
    this.show(translationKey, 'success-snackbar', interpolateParams);
  }

  error(translationKey: string, interpolateParams?: object): void {
    this.show(translationKey, 'error-snackbar', interpolateParams);
  }

  private show(translationKey: string, panelClass: string, interpolateParams?: object): void {
    const message = this.translateService.instant(translationKey, interpolateParams);
    this.snackBar.open(message, '', {
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: [panelClass],
      duration: 5000
    });
  }
}
